import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(
        private authService: AuthService,
        private _router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {


   
        
        sessionStorage.removeItem('urlsesion')
        sessionStorage.setItem('urlsesion', state.url)

        if (state.url === '/office_management') {
            if (!this.authService.isAuthenticateManagement()) {

                this._router.navigate(['/auth/mp_access']);
                return false;
            }

        } else {
            
            if (!this.authService.isAuthenticate()) {
                this._router.navigate(['/auth/sign_in']);
                return false;
            }

        }
        
        
        return true;
    }
}


// WEBPACK FOOTER //
// /app/src/app/shared/security/auth-guard.service.ts